module.exports = __webpack_public_path__ + "static/5-8cd9a601e880477e93ed34cdf440912d.jpeg";